import React from 'react';

interface TabToggleOption {
  id: string;
  label: string;
}

interface TabToggleProps<T = string> {
  // Старые пропсы для обратной совместимости
  isActive?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  
  // Новые пропсы для TabToggle с options
  options?: TabToggleOption[];
  activeTab?: T;
  onTabChange?: (tab: T) => void;
  className?: string;
  radius?: string;
}

export function TabToggle<T = string>({ 
  isActive, 
  children, 
  onClick, 
  options, 
  activeTab, 
  onTabChange, 
  className = "", 
  radius = "rounded-[20px]" 
}: TabToggleProps<T>) {
  // Если переданы options, используем новый интерфейс
  if (options && activeTab !== undefined && onTabChange) {
    return (
      <div className={`bg-[#f5f6f1] relative ${radius} shrink-0 w-full ${className}`}>
        <div className="overflow-clip relative size-full">
          <div className="box-border content-stretch flex flex-row gap-1 items-start justify-start overflow-clip p-[4px] relative">
            {options.map((option) => (
              <div
                key={option.id}
                className={`box-border content-stretch flex flex-row gap-1.5 items-center justify-center overflow-clip px-3 py-2.5 relative ${radius} shrink-0 cursor-pointer transition-all ${
                  activeTab === option.id
                    ? "bg-[#ffffff] shadow-[0px_6px_10px_0px_rgba(27,28,29,0.06),0px_2px_4px_0px_rgba(27,28,29,0.02)]"
                    : "bg-transparent hover:bg-[#e8e9e4]"
                }`}
                onClick={() => onTabChange(option.id as T)}
              >
                <div className={`font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[14px] text-left text-nowrap tracking-[-0.084px] ${
                  activeTab === option.id ? "text-[#e16349]" : "text-[#868c98]"
                }`}>
                  <p className="adjustLetterSpacing block leading-[20px] whitespace-pre">
                    {option.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Старый интерфейс для обратной совместимости
  if (isActive) {
    return (
      <div
        className={`bg-[#ffffff] box-border content-stretch flex flex-row gap-1.5 items-center justify-center overflow-clip px-3 py-2.5 relative ${radius} shadow-[0px_6px_10px_0px_rgba(27,28,29,0.06),0px_2px_4px_0px_rgba(27,28,29,0.02)] shrink-0 cursor-pointer ${className}`}
        onClick={onClick}
      >
        <div className="css-cf07vu font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#e16349] text-[14px] text-left text-nowrap tracking-[-0.084px]">
          <p className="adjustLetterSpacing block leading-[20px] whitespace-pre">
            {children}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`bg-[#f5f6f1] box-border content-stretch flex flex-row gap-1.5 items-center justify-center overflow-clip px-3 py-2.5 relative ${radius} shrink-0 cursor-pointer ${className}`}
      onClick={onClick}
    >
      <div className="css-z8d4os font-['Inter:Medium',_sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#868c98] text-[14px] text-left text-nowrap tracking-[-0.084px]">
        <p className="adjustLetterSpacing block leading-[20px] whitespace-pre">
          {children}
        </p>
      </div>
    </div>
  );
} 